<template>
  <div
    class="lp-loadingbar"
    :class="{
      'lp-loadingbar-start': start,
    }"
    :style="{
      width: progress + '%',
      height: height + 'px',
    }"
  ></div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'lp-loading-bar',
  data() {
    return {
      progress: 0,
      height: 2,
      start: false,
    }
  },
  watch: {
    progress(newValue) {
      if (newValue === 100) {
        setTimeout(() => {
          this.progress = 0
          this.height = 2
        }, 600)
      }
    },
  },
})
</script>
